import BgIco from './_bg-ico';
import Header from './_header';
import AutoScroll from './_auto-scroll';
import Show from './_show';
import PageTtl from './_page-ttl';
import Modal from './_modal';
import Mov from './_mov';

export default class Main {
    constructor() {
        this.bgIco = new BgIco();
        this.header = new Header();
        this.autoScroll = new AutoScroll();
        this.show = new Show(this);
        this.pageTtl = new PageTtl();
        this.modal = new Modal(this);
        this.mov = new Mov();

        this._init();
    }

    _init() {
        this._registerEvent();
    }

    _registerEvent() {
        window.addEventListener('load', () => {
            this.bgIco.execLoop();
            this.autoScroll.appendInner();
            this.show.execLoop();
        });
    }
}
